import { faker } from '@faker-js/faker'

import { Consultation, ConsultationByPurchaseId, ConsultationHistory } from '../../contracts/consultation'

type Country = 'KR' | 'JP'
type SupportedLanguage = 'ko' | 'ja'

export const createConsultation = (overrides: Partial<Consultation> = {}): Consultation => {
  return {
    id: 797932,
    createTime: 1654579763000,
    updateTime: 1654579763000,
    status: 0,
    memberName: '이용현',
    memberCountry: 'KR' as Country,
    memberLang: 'ko' as SupportedLanguage,
    memberPhoneNumber: '01086674355',
    memberPhoneNational: '1086674355',
    memberPhoneCc: '82',
    realPhoneNumber4: '4355',
    useVn: false,
    contactableTime: 'ANYTIME' as Consultation['contactableTime'],
    consultationProcessStatus: 'PENDING' as Consultation['consultationProcessStatus'],
    reservationTime: null,
    treatmentExperience: null,
    reservationTimeList: [],
    operationTime: null,
    lastReservationTime: null,
    memberChangeStateTime: null,
    hospitalChangeStateTime: null,
    rating: null,
    ratingCount: 0,
    reportCount: 0,
    finishEvalTime: null,
    visitedTime: null,
    state: 'NONE',
    reservationCode: null,
    phoneState: 'NONE',
    lastCallTime: null,
    lastCallLength: 0,
    chatState: null,
    chatCase: null,
    smsCount: 0,
    means: 'NORMAL',
    kakaoId: null,
    lineId: null,
    memo: '',
    adminMemo: 'null',
    report: null,
    reportReason: null,
    originStr: 'EVENT',
    origin: 'EVENT',
    originId: 14034,
    originMsg: '토론토 테스트 이벤트 1',
    originImage:
      'https://image2.gnsister.com/images/direct/1638948926486_c522c0e0d8754c84820ef379f0136ef3.jpg?originalImageWidth=1080&originalImageHeight=1080',
    memberSex: 'MALE' as Consultation['memberSex'],
    memberEmail: null,
    memberAge: 19,
    memberBirthYear: 2004,
    memberBirthMonth: 12,
    memberBirthDay: 12,
    memberSido: null,
    memberDeviceType: 'IOS',
    appVersionCode: '0',
    visitBooking: null,
    openCrmDataId: null,
    mediaType: null,
    mediaOriginId: null,
    targetWorked: false,
    targetPageIds: null,
    treatmentMenu: null,
    happyHour: null,
    applyPackageTime: null,
    operationType: 'SURGICAL' as Consultation['operationType'],
    treatmentIds: ' 1 ',
    specialOfferPrice: 39000,
    cost: null,
    pointRedeemedAmount: null,
    pointCurrency: null,
    targetPageIdList: [],
    trackingSrc: null,
    opTags: ' 기타 ',
    operationTags: ' 등제모 ',
    srcIp: '117.111.1.206',
    chatRoomId: null,
    sameHospitalEstimateId: null,
    referrer: null,
    motive: null,
    etc: null,
    photos: null,
    estimateId: null,
    eventId: 14034,
    realmodelId: null,
    reviewId: null,
    tenderId: null,
    liveConsultationId: null,
    liveConsultationDoctorName: null,
    doctorId: null,
    vnConsId: null,
    operationDoctorId: null,
    purchaseId: null,
    recentConsultationMemberCount: 0,
    recentOperatedMemberCount: 0,
    hasOldEvaluations: true,
    type: 'CONSULTATION',
    originType: 'EVENT',
    hasAppliedPackage: false,
    hasEvalProcess: [],
    canEvalProcess: [],
    hospitalPointId: 1382964,
    isDupCase: true,
    estimateTitle: '토론토 테스트 이벤트 1',
    eventHotRating: null,
    realmodelTitle: '토론토 테스트 이벤트 1',
    reviewTitle: '토론토 테스트 이벤트 1',
    hasVisited: false,
    hospitalRealNumber: '08012345678',
    memberChangeState: false,
    hasToApproveChangedState: false,
    nextEvalProcess: null,
    memberId: 2794717,
    consTypeKr: '상담신청',
    hospitalId: 4049,
    realPoint: 0,
    treatmentList: [
      {
        id: 1,
        name: '튠아이',
        label: 'test',
      },
    ],
    writerId: 2794717,
    hospitalName: '토론토클리닉',
    eventTitle: '토론토 테스트 이벤트 1',
    isAnonymousCons: false,
    treatmentIdList: [1],
    opTagList: ['기타'],
    canNormalConsultation: true,
    operationTagList: ['등제모'],
    isFromWeb: false,
    hospitalInfo: {
      id: 4049,
      createTime: null,
      updateTime: 1654579125000,
      name: '토론토클리닉',
      introduction: '안녕하세요. 토론토클리닉입니다.\n',
      district: null,
      subwayCode: '',
      mainImage:
        'https://image2.gnsister.com/images/direct/1638944692839_b7612310944843179c440bdd15837a3c.jpg?originalImageWidth=1080&originalImageHeight=431',
      profileImage:
        'https://image2.gnsister.com/images/direct/1638944701553_9268a0e3ab01481eb59ebeade2f336de.png?originalImageWidth=496&originalImageHeight=496',
      introImage:
        'https://image2.gnsister.com/images/direct/1638944698662_248924e9a6424085ac040f6b884c94e5.jpg?originalImageWidth=600&originalImageHeight=400',
      photos: [],
      cardLevel: 3,
      rating: 5.8,
      ratingCount: 5,
      pageCount: 2,
      reviewCount: 0,
      priority: 0,
      sigunguCode: '11680',
      sido: null,
      sigungu: null,
      authTenderView: true,
      authEstimateWrite: false,
      authChatConsultation: false,
      authForeignConsultation: false,
      basicRN: null,
      basicVN: '05000000000',
      officeHours:
        '\n  "MON" : "10:00-19:00",\n  "TUE" : "10:00-19:00",\n  "WED" : "10:00-19:00",\n  "THU" : "10:00-19:00",\n  "FRI" : "10:00-19:00",\n  "SAT" : "10:00-16:00"\n',
      officeHoursJson:
        '{"MON":"10:00-19:00","TUE":"10:00-19:00","WED":"10:00-19:00","THU":"10:00-19:00","FRI":"10:00-19:00","SAT":"10:00-16:00"}',
      officeHoursEtc: null,
      country: 'KR',
      address: '서울 강남구 테헤란로 124 삼원타워',
      addressEn: '124, Teheran-ro, Gangnam-gu, Seoul, Korea',
      zipCode: '06234',
      lat: null,
      lng: null,
      mainTel1: '080',
      mainTel2: '1234',
      mainTel3: '5678',
      emailList: ['jane.jeon@healingpaper.com'],
      supportingLangList: [],
      agreedToTermsTime: 1642411974000,
      canChatConsultation: false,
      isOfficeHour: true,
      canPhoneConsultation: false,
      canNormalConsultation: true,
      treatmentMenuId: null,
      recentConsultationMemberCount: 19,
      recentVisitedMemberCount: 2,
      recentOperatedMemberCount: 1,
      entranceType: 'ENTRANCE',
      assessmentState: 'GROWTH',
      title: '토론토클리닉',
      treatmentCategoryTagIdList: [413, 412],
      opTagList: [],
      cardImage:
        'https://image2.gnsister.com/images/direct/1638944701553_9268a0e3ab01481eb59ebeade2f336de.png?originalImageWidth=496&originalImageHeight=496',
      badgeCodeList: [],
      awardList: [],
      sidoCode: '11',
      ratingShow: false,
      isNew: false,
      amplitudeTreatmentInfo: {
        treatmentIdList: [],
        treatmentNameList: [],
        treatmentCategoryTagIdList: [413, 412],
        treatmentCategoryTagNameList: ['눈성형', '코성형'],
        treatmentGroupTagNameList: [],
        concernBodyPartTagNameList: [],
        concernTagNameList: [],
        treatmentLabelList: [],
        treatmentCategoryTagLabelList: ['눈성형', '코성형'],
        treatmentGroupTagLabelList: [],
        concernBodyPartTagLabelList: [],
        concernTagLabelList: [],
        operationType: 'UNKNOWN',
        opTagList: [],
        operationTagList: [],
      },
      treatmentCategoryTagList: [
        {
          id: 413,
          name: '눈성형',
          label: '눈성형',
          tagMeta: {
            name: 'TREATMENT_CATEGORY',
            nameKr: '시술대분류',
          },
        },
        {
          id: 412,
          name: '코성형',
          label: '코성형',
          tagMeta: {
            name: 'TREATMENT_CATEGORY',
            nameKr: '시술대분류',
          },
        },
      ],
      offlinePointRedemptionEnabled: false,
    },
    specialOfferPriceCurrency: 'KRW',
    skipped: false,
    createdInADay: true,
    hospitalContactNumber: '08012345678',
    chat: false,
    memberPhoneNumberForAdmin: '01086674355',
    originKr: '이벤트',
    originName: '이벤트',
    consProcess: 'CONS_START',
    canApplyPackage: false,
    stateKr: '신규상담',
    amplitudeTreatmentInfo: {
      treatmentIdList: [1],
      treatmentNameList: ['튠아이'],
      treatmentCategoryTagIdList: [537],
      treatmentCategoryTagNameList: ['제모'],
      treatmentGroupTagNameList: ['바디제모'],
      concernBodyPartTagNameList: ['제모'],
      concernTagNameList: ['바디제모'],
      treatmentLabelList: ['test'],
      treatmentCategoryTagLabelList: ['제모'],
      treatmentGroupTagLabelList: ['바디제모'],
      concernBodyPartTagLabelList: ['제모'],
      concernTagLabelList: ['바디제모'],
      operationType: 'NONSURGICAL',
      opTagList: ['기타'],
      operationTagList: ['등제모'],
    },
    treatmentCategoryTagList: [
      {
        id: 537,
        name: '제모',
        label: '제모',
        tagMeta: {
          name: 'TREATMENT_CATEGORY',
          nameKr: '시술대분류',
        },
      },
    ],
    canChatConsultation: false,
    canPhoneConsultation: false,
    ...overrides,
  }
}

export const createConsultationByPurchaseId = (
  overrides: Partial<ConsultationByPurchaseId> = {},
): ConsultationByPurchaseId => {
  return {
    id: faker.number.int(),
    memberId: faker.number.int(),
    hospitalId: faker.number.int(),
    purchaseId: faker.number.int(),
    requestedReservedAt: new Date().toISOString(),
    confirmedReservedAt: new Date().toISOString(),
    originType: 'EVENT',
    originId: faker.number.int(),
    originTitle: faker.word.noun(),
    originImage: faker.image.url(),
    specialOfferPrice: faker.number.int(),
    ...overrides,
  }
}

export const createConsultationHistory = (overrides: Partial<ConsultationHistory> = {}): ConsultationHistory => {
  return {
    consultation: createConsultation(),
    purchase: {
      id: faker.number.int(),
      status: faker.word.noun(),
    },
    ...overrides,
  }
}

export * from './UserConsultation'
